
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class DenominationGrid extends Serenity.EntityGrid<DenominationRow, any> {
        protected getColumnsKey() { return 'OMS.Denomination'; }
        protected getDialogType() { return DenominationDialog; }
        protected getIdProperty() { return DenominationRow.idProperty; }
        protected getInsertPermission() { return DenominationRow.insertPermission; }
        protected getLocalTextPrefix() { return DenominationRow.localTextPrefix; }
        protected getService() { return DenominationService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}